import React from 'react';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

/**
 * ラジオボタンの中身（オプションあり）
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function KaraokeOrderFormView1WithOptionView({
  title,
  image,
  amountWithTax,
  amountWithoutTax,
  children,
} : {
  title: string,
  image: string,
  amountWithTax: number,
  amountWithoutTax: number,
  children: React.ReactNode,
}) {
  return (
    <div className="radio__wrap">
      <h3 className="radio__header">
        <span className="radio__title">
          {title}
          <img
            alt=""
            src={image}
            className="radio__icon"
          />
        </span>

      </h3>
      <p className="radio__text">{children}</p>
      <p className="radio__price">
        {`${amountWithoutTax > 0 ? '+' : ''}${CurrencyUtility.format(amountWithoutTax)}`}
        <span className="radio__price_small">円</span>
        <div className="radio__price_taxin">{`${amountWithTax > 0 ? '+' : ''}${CurrencyUtility.format(amountWithTax)}円（税込）`}</div>
      </p>
    </div>
  );
}
